import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { compose, withStateHandlers } from 'recompose';
import { Button } from 'react-bootstrap';


import BaseInput from '../../fields/BaseInput';


const propTypes = exact({
  /* eslint-disable react/no-unused-prop-types */
  reason: PropTypes.string,
  /* eslint-enable react/no-unused-prop-types */

  reasonInput: PropTypes.string,
  ticketNumber: PropTypes.string.isRequired,
  expected: PropTypes.bool.isRequired,
  setReason: PropTypes.func.isRequired,
  handleExpectedToggle: PropTypes.func.isRequired,
});


const MissingTicketNumberRow = (props) => {
  const {
    ticketNumber,
    expected,
    reasonInput,
    handleExpectedToggle,
    setReason,
  } = props;

  const state = expected ? 'Missing' : 'Not Expected';
  const buttonMsg = expected ? 'Not Expected' : 'Missing';
  const disableButton = reasonInput === '';

  return (
    <tr>
      <td>{ticketNumber}</td>
      <td>{state}</td>
      <td>
        <BaseInput
          componentClass="input"
          componentProps={{}}
          input={{
            onChange: setReason,
            value: reasonInput,
            disabled: !expected,
          }}
        />
      </td>
      <td>
        <div style={{ textAlign: 'center' }}>
          <Button
            disabled={disableButton}
            onClick={() => { handleExpectedToggle(reasonInput); }}
          >
            Mark {buttonMsg}
          </Button>
        </div>
      </td>
    </tr>
  );
};


MissingTicketNumberRow.propTypes = propTypes;


const setReason = (state, props) => {
  return (e) => {
    const { value } = e.target;
    return {
      reasonInput: value,
    };
  };
};


const stateHandlers = withStateHandlers(
  ((props) => {
    const { reason } = props;
    const reasonInput = (reason) || '';
    return {
      reasonInput,
    };
  }),
  {
    setReason,
  },
);


const enhance = compose(stateHandlers);


export default enhance(MissingTicketNumberRow);
